import BottomSheetHeader from '@components/BottomSheetHeader';
import Button from '@components/Button';
import Column from '@components/Column';
import FileUploader from '@components/FileUploader';
import Note from '@components/Note';
import Row from '@components/Row';
import Switch from '@components/Switch';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import useToast from '@hooks/ui/useToast';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { ChangeEventHandler, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tesseract from 'tesseract.js';

import styles from './styles.module.scss';

const codeExp = /^\d{4} \d{4} \d{4} \d{4}$/;

declare module '@stackflow/config' {
    interface Register {
        NewGiftBottomSheet: {};
    }
}

const NewGiftBottomSheet: ActivityComponentType<'NewGiftBottomSheet'> = () => {
    const toast = useToast();
    const { t } = useTranslation('gift');
    const [isOcr, setIsOcr] = useState<boolean>(true);
    const handleFileChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        const imagePath = URL.createObjectURL(e.target.files![0]);
        Tesseract.recognize(imagePath, 'eng+kor')
            .then((res) => {
                const { text } = res.data;
                const rows = text.split('\n');
                const code = rows.find((row) => codeExp.test(row));
                if (code) {
                    toast.success(t('newGift.codeRecognized', { code }));
                } else {
                    toast.error(t('newGift.codeNotRecognized'));
                }
            })
            .catch((error: unknown) => {
                console.error(error);
                toast.error(t('newGift.ocrError'));
            });
    };
    return (
        <BottomSheet>
            <BottomSheetHeader>
                {t('newGift.title')}
            </BottomSheetHeader>
            <Column className={styles.container} spacing={32}>
                <Row fullWidth justify='flex-end'>
                    <Switch checked={!isOcr}
                        setChecked={() => setIsOcr(!isOcr)}
                        leftText={t('newGift.imageUpload')}
                        rightText={t('newGift.manualInput')} />
                </Row>
                {isOcr ? (
                    <Column fullWidth spacing={12}>
                        <Text size='lg' fontWeight='bold' color={colors.gray7}>
                            {t('newGift.uploadLabel')}
                        </Text>
                        <FileUploader onChange={handleFileChange}/>
                    </Column>
                ) : (
                    <TextField placeholder={t('newGift.placeholder')}
                        inputMode='numeric'
                    />
                )}

                <Note title={t('newGift.noteTitle')}>
                    {t('newGift.noteContent')}
                </Note>
                <Button fullWidth>{t('newGift.register')}</Button>
            </Column>
        </BottomSheet>
    );
};

export default NewGiftBottomSheet;
